import { Component, OnInit, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GraphUser } from '../models/graph-user.model';
import { DataService } from '../services/data.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import _ from 'lodash';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-approver-dialog',
  templateUrl: './approver-dialog.component.html',
  styleUrls: ['./approver-dialog.component.scss'],
  standalone: false,
})
export class ApproverDialogComponent implements OnInit {
  approverList: any[];
  additionalApprovers: GraphUser[];
  additionalApproverControl: FormControl[];
  additionalApproverOptions: GraphUser[][];
  doaAmounts: number[];
  xmlDoc: any;
  parser: DOMParser;

  onYes = new EventEmitter();

  constructor(
    private dataService: DataService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ApproverDialogComponent>
  ) {
    this.parser = new DOMParser();
  }

  ngOnInit() {
    this.approverList = JSON.parse(JSON.stringify(this.data.approverList));
    this.additionalApprovers = JSON.parse(JSON.stringify(this.data.additionalApprovers));
    this.doaAmounts = JSON.parse(JSON.stringify(this.data.doaAmounts));
    this.additionalApproverControl = [];
    this.additionalApproverOptions = [];
    for (let i = 0; i < this.approverList.length; i++) {
      this.additionalApproverControl.push(new FormControl());
      this.additionalApproverOptions.push([]);
    }
  }

  addNewAdditionalApprover() {
    this.additionalApproverControl.push(new FormControl());
    this.additionalApproverOptions.push([]);
    this.approverList.push('');
    this.doaAmounts.push(0);
    this.additionalApprovers.push(null);
  }

  deleteApprover(index: number) {
    this.additionalApproverControl.splice(index, 1);
    this.additionalApproverOptions.splice(index, 1);
    this.additionalApprovers.splice(index, 1);
    this.approverList.splice(index, 1);
    this.doaAmounts.splice(index + 1, 1);
  }

  additionalApproverSelected(event: any, index: number) {
    this.getDOA(event.mailNickname, index + 1);
    this.approverList[index] = event;
  }

  getDOA(lanID: string, index: number) {
    this.doaAmounts[index] = 0;
    let doc = document.implementation.createDocument('', '', null);
    const pi = doc.createProcessingInstruction('xml', 'version="1.0" encoding="UTF-8"');
    doc.insertBefore(pi, doc.firstChild);
    let elem1 = doc.createElement('soapenv:Envelope');
    elem1.setAttribute('xmlns:soapenv', 'http://schemas.xmlsoap.org/soap/envelope/');
    elem1.setAttribute('xmlns:web', 'http://duke-energy.com/webservices/');
    let elem2 = doc.createElement('soapenv:Header');
    let elem3 = doc.createElement('soapenv:Body');
    let elem4 = doc.createElement('web:GetDoaInformationByLanid');
    let elem5 = doc.createElement('web:lanids');
    let elem6 = doc.createElement('web:string');
    elem6.innerHTML = lanID;
    elem5.appendChild(elem6);
    elem4.appendChild(elem5);
    elem3.appendChild(elem4);
    elem1.appendChild(elem2);
    elem1.appendChild(elem3);
    doc.appendChild(elem1);
    let finalString = doc.documentElement.outerHTML;
    this.dataService.getDOA(finalString).subscribe(
      (result) => {
        this.xmlDoc = this.parser.parseFromString(result, 'text/xml');
        if (this.xmlDoc.getElementsByTagName('StatusCode')[0].innerHTML === 'ERROR') {
          /*let dataStructure;
        let error = this.xmlDoc.getElementsByTagName("StatusCodeMsg")[0].innerHTML;
        dataStructure = {
          error: true,
          data: error,
          isDOA: true
        }
        this.dialog.open(SuccessDialogComponent, {
          disableClose: true,
          data: dataStructure
        });*/
          this.doaAmounts[index] = 0;
          console.log('error');
          let errorType = 'Get DOA Error';
          let errorDescription = '';
          errorDescription = errorDescription.concat(
            'Get DOA Error Returned from Endpoint - ' +
              this.xmlDoc.getElementsByTagName('StatusCodeMsg')[0].innerHTML +
              ' - LAN ID: ' +
              lanID
          );
          let dataStructure = {
            errorType: errorType,
            errorDescription: errorDescription,
          };
          this.dialog.open(ErrorDialogComponent, {
            data: dataStructure,
            disableClose: true,
          });
        } else {
          this.doaAmounts[index] = Number(this.xmlDoc.getElementsByTagName('Amount')[0].innerHTML);
        }
      },
      (error) => {
        this.doaAmounts[index] = 0;
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat('Get DOA Error - ', error.error.message);
        } else {
          errorDescription = errorDescription.concat('Get DOA Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  deleteAdditionalApproverValue(i: number) {
    this.additionalApprovers[i] = '' as any;
  }

  autocompleteName(index: number) {
    return 'additionalApprover' + index.toString();
  }

  displayFnAdditionalApprover(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    } else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    } else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    } else {
      return value;
    }
  }

  searchUsersAdditionalApprover(searchText: any, index: number) {
    this.dataService.searchUsers(searchText, { excludeContractors: true }).subscribe((result) => {
      this.additionalApproverOptions[index] = _.orderBy(result['value'], ['surname', 'givenName']);
      document.getElementsByName(this.autocompleteName(index))[0].focus();
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveAndClose() {
    let dataStructure = {
      approverList: this.approverList,
      doaAmounts: this.doaAmounts,
    };
    this.onYes.emit(dataStructure);
    this.dialogRef.close();
  }
}
